import * as S from "./Legends.style";
import { formatDisplay } from "../../../common/functions/format";
import { ShipOperationStatus } from "../../../common/types/ship";
import { EquipmentOperationStatus } from "../../../common/types/equipment";
import { LedLegendItem } from "../../atoms/LegendItem/LedLegendItem";
import { StatusLegendItem } from "../../atoms/LegendItem/StatusLegendItem";

interface LegendsProps {
  title?: string;
  type: "led-monitor" | "led-equip" | "led-alarm" | "sailing-info" | "uptime";
  data?: any;
  children?: React.ReactElement;
  shipOperationStatus?: ShipOperationStatus | EquipmentOperationStatus;
}

export const Legend = ({
  title,
  type,
  data,
  children,
  shipOperationStatus,
}: LegendsProps) => {
  return (
    <S.LegendBox>
      {title && (
        <>
          <S.LegendTit>{title}</S.LegendTit>
          <S.TitBorder />
        </>
      )}

      <S.LegendList $type={type}>
        {/* 데이터 모니터링 LED */}
        {type === "led-monitor" && (
          <>
            <LedLegendItem ledColor="green" title="정상(Normal)" />
            <LedLegendItem ledColor="yellow" title="대기(Ready)" />
            <LedLegendItem ledColor="red" title="오류(Errored)" />
          </>
        )}

        {/* 장비 모니터링 LED */}
        {type === "led-equip" && (
          <>
            <LedLegendItem ledColor="green" title="정상(Normal)" />
            <LedLegendItem ledColor="yellow" title="경고(Warning)" />
            <LedLegendItem ledColor="red" title="이상(Critical)" />
            <LedLegendItem ledColor="gray" title="진단불가" />
          </>
        )}

        {/* 알람 모니터링 LED */}
        {type === "led-alarm" && (
          <>
            <LedLegendItem ledColor="green" title="Normal" />
            <LedLegendItem ledColor="yellow" title="Warning" />
            <LedLegendItem ledColor="red" title="Critical" />
          </>
        )}

        {/* 장비 모니터링 LED */}
        {type === "sailing-info" && (
          <>
            <StatusLegendItem
              iconType="speed"
              title="속도"
              value={`${formatDisplay(shipOperationStatus?.dashboard1)} kn`}
            />
            {/* <StatusLegendItem
              iconType="wind"
              title="풍향"
              value={`${formatDisplay(shipOperationStatus?.dashboard2)}`}
            />
            <StatusLegendItem
              iconType="pitch"
              title="피치"
              value={`${formatDisplay(shipOperationStatus?.dashboard3)}˚`}
            />
            <StatusLegendItem
              iconType="rolling"
              title="롤링"
              value={`${formatDisplay(shipOperationStatus?.dashboard4)}˚`}
            /> */}
          </>
        )}
        {type === "uptime" && <li className="uptime-item">{children}</li>}
      </S.LegendList>
    </S.LegendBox>
  );
};
